import Icon from '../components/Icon.vue'

Icon.register({
  print: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 192c35.3 0 64 28.7 64 64v112c0 8.8-7.2 16-16 16h-48v96c0 17.7-14.3 32-32 32h-320c-17.7 0-32-14.3-32-32v-96h-48c-8.8 0-16-7.2-16-16v-112c0-35.3 28.7-64 64-64v-160c0-17.7 14.3-32 32-32h274.7c8.5 0 16.6 3.4 22.6 9.4l45.3 45.3c6 6 9.4 14.1 9.4 22.6v114.8zM384 448v-96h-256v96h256zM384 224v-96h-48c-8.8 0-16-7.2-16-16v-48h-192v160h256zM432 296c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/print.js
// module id = 1666
// module chunks = 0